import { jsxs as c, jsx as o } from "react/jsx-runtime";
import l from "classnames";
import { forwardRef as n } from "react";
import r from "./index.es5600.js";
import { ChipDecoration as p } from "./index.es5601.js";
const N = n(
  ({ label: e, ColorIndicator: s, LeftIcon: t, size: m, isClickable: i }, a) => /* @__PURE__ */ c(
    "div",
    {
      ref: a,
      className: l(r.content, { [r.clickable]: i }),
      children: [
        /* @__PURE__ */ o(p, { ColorIndicator: s, LeftIcon: t, size: m }),
        /* @__PURE__ */ o("span", { className: r.label, children: e })
      ]
    }
  )
);
export {
  N as ChipContent
};
//# sourceMappingURL=index.es813.js.map
